import useUser from './useUser';
import { ComponentType } from 'react';

function withUser<P extends object>(Component: ComponentType<P>) {
	return function WrappedComponent(props: P) {
		const userProps = useUser();
		return (
			<Component
				{...props}
				{...userProps}
			/>
		);
	};
}

export default withUser;
